import styled from "styled-components"
import { StatusBar } from "components/common"

export const StatusBarStyled = styled(StatusBar)`
  margin-bottom: 24px;
`